export const CLEAR_NEW_JOB_DATA = 'CLEAR_NEW_JOB_DATA';

//──── Info ──────────────────────────────────────────────────────────────────────────
export const NEW_JOB_SET_INFO = 'NEW_JOB_SET_INFO';

//──── Filters ───────────────────────────────────────────────────────────────────────────
export const NEW_JOB_UPDATE_FILTERS = 'NEW_JOB_UPDATE_FILTERS';

//──── Appointments ───────────────────────────────────────────────────────────────────────────
export const NEW_JOB_SET_APPOINTMENTS = 'NEW_JOB_SET_APPOINTMENTS';

//──── Details ───────────────────────────────────────────────────────────────────────────
export const NEW_JOB_SET_DETAILS = 'NEW_JOB_SET_DETAILS';
